<template>
  <section id="section1" class="section" style="position: relative">
    <div class="more-details mt-app-header " style="">
      <MoreDetails7></MoreDetails7>
    </div>
  </section>
  <section id="section2" class="section" style="position: relative">
    <div class="client-footer">
      <ClientFooter></ClientFooter>
    </div>
  </section>
</template>

<style scoped lang="scss">
@media (max-width: 600px) {
  .mt-app-header {
    margin: 15% 2% 2% !important;
  }
}

@media (max-width: 1600px) and (min-width: 991px) {
  .mt-app-header {
    margin: 8% 2% 8% !important;
  }
}
@media (max-width: 990px) and (min-width: 601px) {
  .mt-app-header {
    margin: 8% 2% 2% !important;
  }
}

@media (min-width: 1601px) {
  .mt-app-header {
    margin: 5% 2% 2% !important;
  }
}
</style>
<script>

import MoreDetails7 from "@/components/moreDetails/MoreDetailsRoster7Screen.vue"
import ClientFooter from "@/components/footers/ClientFooter.vue";

export default {
  name: 'moreDetails',
  components: {
    MoreDetails7,
    ClientFooter
  }
}
</script>
